import { from, Observable, ObservableInput } from 'rxjs';
import { concatAll } from 'rxjs/operators';

export function forkJoinSerial<T>(sources: ObservableInput<T>[]): Observable<T[]> {
  return new Observable((subscriber) => {
    const len = sources.length;

    if (len === 0) {
      subscriber.complete();
      return;
    }

    const values = new Array(len);

    let i = 0;
    let subscription = from(sources)
      .pipe(concatAll())
      .subscribe({
        complete: () => {
          subscriber.next(values);
          subscriber.complete();
        },
        error: (err) => {
          subscriber.error(err);
        },
        next: (value) => {
          values[i++] = value;
        },
      });

    subscriber.add(() => {
      return () => {
        subscription.unsubscribe();
      };
    });
  });
}
